module.exports = "/_next/static/images/003744743a9d306fe4bb9c78524ff3f2-icon_beach.png.webp";